<app-loading-spinner
  *ngIf="ratesFetched || !pageLoad; else showCart"
></app-loading-spinner>
<ng-template #showCart>
  <main
    *ngIf="!ratesFetched || pageLoad"
    class="font-mont lg:bg-[#FBFBFB] mx-3 sm:p-0"
  >
    <section>
      <app-header
        class="hidden lg:block"
        [storeName]="stores"
      ></app-header>
    </section>
    <section
      class="block px-6 lg:px-0 mx-0 xl:flex lg:mx-40 mt-2 lg:mt-8 lg:mb-6 shadow-md lg:shadow-none"
    >
      <div class="block lg:hidden">
        <div class="py-4 lg:py-0 flex items-center justify-between lg:justify-start">
          <img src="../../../assets/svg/back.svg" alt="back" class="cursor-pointer" (click)="onBackClick()" />
          <p class="hidden lg:block font-medium text-zestBlack text-lg font-mont px-4">Back</p>
          <h2 class="text-zestBlack block lg:hidden font-semibold text-2xl">My Cart</h2>
          <p class="block lg:hidden text-2xl">&nbsp;</p>
        </div>
      </div>
      <div class="hidden lg:block">
        <div
          *ngIf="openTab === 0; else showBreadCrumbs"
          class="py-4 lg:py-0 flex items-center justify-between lg:justify-start"
        >
          <img
            src="../../../assets/svg/back.svg"
            alt="back"
            class="cursor-pointer"
            (click)="onBackClick()"
          />
          <p class="hidden lg:block font-medium text-zestBlack text-lg font-mont px-4">Back</p>
          <p class="text-zestBlack block lg:hidden font-semibold text-2xl">My Cart</p>
          <p class="block lg:hidden text-2xl">&nbsp;</p>
        </div>
        <ng-template #showBreadCrumbs>
          <ul
            class="flex mb-0 list-none no-scrollbar lg:flex-wrap pt-1 flex-row lg:w-full overflow-x-scroll touch-pan-x w-full flex-nowrap lg:overflow-hidden"
          >
            <li
              class="mr-2 lg:mr-2 last:mr-0 text-left"
              *ngFor="let tab of tabs; let i = index; let last = last"
            >
              <p
                class="text-xs lg:text-base font-medium cursor-pointer block leading-normal"
                [ngClass]="{ 'text-zestGrey': openTab !== i }"
                (click)="toggleTabs(i, tab)"
              >
                {{ tab }}
                <span class="inline-block mx-3 text-zestGrey" [ngClass]="{ hidden: last }">&gt;</span>
              </p>
            </li>
          </ul>
        </ng-template>
      </div>
    </section>

    <section class="block md:mx-6 xl:flex lg:mx-40 mt-8 mb-6">
      <div class="px-0 py-0 my-0 rounded xl:pr-6 grow w-full xl:w-8/12">
        <div class="flex items-center">
          <div class="w-full">
            <div class="relative flex flex-col min-w-0 break-words bg-white w-full mb-6">
              <form [formGroup]="multiStageForm" class="">

                <!-- Tab 0: Cart -->
                <div [ngClass]="{ hidden: openTab !== 0, block: openTab === 0 }">
                  <app-cart [open]="openTab"></app-cart>
                </div>

                <!-- Tab 1: Delivery Detail -->
                <div [ngClass]="{ hidden: openTab !== 1, block: openTab === 1 }">
                  <app-delivery-detail
                    [deliveryDetail]="multiStageForm"
                    [availableShipping]="shippingMethods"
                    [order]="createOrderObj()"
                    [storeCode]="stores?.store_code"
                    (shippingValueEmitter)="handleShipping($event)"
                    (orderValueEmitter)="handleOrderValue($event)"
                    (discountApplied)="handleDiscountApplied($event)"
                  ></app-delivery-detail>
                </div>

                <!-- Tab 2: Shipping -->
                <div [ngClass]="{ hidden: openTab !== 2, block: openTab === 2 }">
                  <app-shipping
                    [shipping]="multiStageForm"
                    [availableShipping]="shippingMethods"
                    [regions]="regionOptions"
                    [rates]="deliveryRates"
                    (deliveryValueEmmitter)="handleDeliveryCharge($event)"
                    (formValidEmitter)="handleFormValid($event)"
                    (selectedShippingPartnerEmitter)="handleSelectedShipPartner($event)"
                  ></app-shipping>
                </div>

                <!-- Tab 3: Summary -->
                <div [ngClass]="{ hidden: openTab !== 3, block: openTab === 3 }">
                  <app-cart [open]="openTab"></app-cart>
                </div>

                <!-- Tab 4 -->
                <div [ngClass]="{ hidden: openTab !== 4, block: openTab === 4 }"></div>

              </form>
            </div>
          </div>
        </div>
      </div>

      <!-- order summary div -->
      <div
        class="rounded grow w-full xl:w-96 bg-white"
        *ngIf="cartItems"
      >
        <div class="bg-white grow lg:py-[32px] lg:px-8">
          <h2 class="pb-6 text-zestBlack text-base lg:text-2xl font-medium">
            Order Summary
          </h2>
          <hr class="border-zestNeutral" />

          <!-- No. of Items -->
          <div class="flex justify-between items-center py-5">
            <h4 class="text-zestLabel text-sm lg:text-base">No. of Items</h4>
            <p class="text-zestLabel text-sm lg:text-base">
              {{ store.reduceCartQuantity() || 0 }}
            </p>
          </div>
          <hr class="border-zestNeutral" />

          <!-- ── Discounted Items row (shown only when discount is valid) ── -->
          <div
            *ngIf="discountResponse?.valid && discountResponse?.productDetails?.length > 0"
            class="flex justify-between items-center py-5"
          >
            <h4 class="text-zestLabel text-sm lg:text-base">Discounted Items</h4>
            <!-- Clickable link that opens the modal -->
            <button
              type="button"
              (click)="openDiscountedItemsModal()"
              class="text-[#5925DC] text-sm lg:text-base font-semibold underline underline-offset-2 hover:opacity-75 transition-opacity duration-150 cursor-pointer bg-transparent border-none p-0"
            >
              {{ discountedItemsLabel }}
            </button>
          </div>
          <hr
            *ngIf="discountResponse?.valid && discountResponse?.productDetails?.length > 0"
            class="border-zestNeutral"
          />

          <!-- Subtotal -->
          <div class="flex justify-between items-center py-5">
            <h4 class="text-zestLabel text-sm lg:text-base">Subtotal</h4>
            <p class="text-zestLabel text-sm lg:text-base">
              {{ store.reduceCartPrice() | currency : "₦ " }}
            </p>
          </div>
          <hr class="border-zestNeutral" />

          <!-- Delivery fee -->
          <div class="py-4" *ngIf="shippingOption !== 'PICKUP_IN_STORE'">
            <div
              *ngIf="!(deliveryAmount || deliveryRates)"
              class="flex justify-between items-center"
            >
              <h4 class="text-zestLabel text-sm lg:text-base">Delivery fee</h4>
              <p class="text-zestLabel text-sm lg:text-base">Not added yet</p>
            </div>
            <div
              *ngIf="deliveryAmount || deliveryRates"
              class="flex justify-between items-center"
            >
              <h4 class="text-zestLabel text-sm lg:text-base">Delivery fee</h4>
              <p *ngIf="deliveryAmount" class="text-zestLabel text-sm lg:text-base">
                {{ deliveryAmount | currency : "₦ " }}
              </p>
            </div>
          </div>
          <hr class="border-zestNeutral" />

          <!-- Total -->
          <div class="flex justify-between items-center py-4">
            <h2 class="text-zestBlack text-lg lg:text-2xl font-medium">Total</h2>
            <p class="text-zestBlack text-lg lg:text-2xl font-medium">
              {{ this.total() | currency : "₦ " }}
            </p>
          </div>
          <hr class="border-zestNeutral" />
        </div>

        <!-- ── Action Buttons ── -->
        <div class="flex flex-col items-center">

          <!-- PICKUP payment options (Tab 1) -->
          <div class="" *ngIf="openTab === 1 && receivedValue === 'PICKUP_IN_STORE' && isAddressValid">
            <div class="w-full h-[52px] bg-ZTN-200 flex items-center mb-6">
              <h3 class="lg:text-xl text-lg font-bold text-zestBlack pl-8">Payment Options</h3>
            </div>
            <div class="px-[17px]">
              <div
                *ngFor="let option of options"
                class="mb-2 cursor-pointer transition-all duration-200"
                (click)="selectOption(option.value)"
              >
                <label class="grid grid-cols-12 cursor-pointer">
                  <div
                    class="w-6 h-6 col-span-1 rounded-full border-2 flex items-center justify-center transition-colors duration-200"
                    [ngClass]="{
                      'border-gray-400': selectedOption !== option.value,
                      'border-green-500': selectedOption === option.value
                    }"
                  >
                    <div
                      class="w-3 h-3 rounded-full transition-colors duration-200"
                      [ngClass]="{
                        'bg-transparent': selectedOption !== option.value,
                        'bg-green-500': selectedOption === option.value
                      }"
                    ></div>
                  </div>
                  <div class="col-span-11 text-[#101828]">
                    <h4 class="text-base font-bold text-[#101828]">{{ option.title }}</h4>
                    <p class="text-sm text-[#667085] font-medium">{{ option.description }}</p>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <!-- Tab 0: Proceed to Shipping -->
          <button
            *ngIf="openTab === 0"
            (click)="toggleTabs(tabs.indexOf('Delivery detail'))"
            [disabled]="store.reduceCartQuantity() < 1 || orderCreated || deliveryRates || pickup"
            class="bg-zestBlack block text-white rounded-lg py-4 px-8 w-[90%] mx-auto text-sm lg:text-base disabled:bg-zestNeutral disabled:text-zestNeutral-300"
          >
            Proceed to Shipping
          </button>

          <!-- Tab 1 PICKUP: Proceed to Payment -->
          <button
            *ngIf="openTab === 1 && receivedValue === 'PICKUP_IN_STORE' && isAddressValid"
            (click)="placePickupOrder()"
            [disabled]="receivedValue !== 'PICKUP_IN_STORE'"
            class="bg-zestBlack block text-white rounded-lg py-4 px-8 mt-3 w-[90%] mx-auto text-sm lg:text-base"
          >
            <mat-spinner
              [diameter]="18"
              class="justify-center items-center flex mx-auto text-zestWhite py-2 px-6"
              *ngIf="createPickupOrder; else addProduct"
            ></mat-spinner>
            <ng-template #addProduct><p>Proceed to Payment</p></ng-template>
          </button>

          <!-- Tab 1 SHIP: Proceed to Shipping -->
          <button
            *ngIf="openTab === 1 && receivedValue !== 'PICKUP_IN_STORE'"
            (click)="toggleTabs(tabs.indexOf('Shipping'))"
            [disabled]="orderCreated || deliveryRates || !receivedValue || isAddressDTOInvalid()"
            class="bg-zestBlack block text-white rounded-lg py-4 px-8 mt-3 w-[90%] mx-auto text-sm lg:text-base disabled:bg-zestNeutral disabled:text-zestNeutral-300"
          >
            Proceed to Shipping
          </button>

          <!-- Tab 2: Place Order -->
          <button
            *ngIf="openTab === 2 && receivedValue !== 'PICKUP_IN_STORE'"
            (click)="placeShipOrder()"
            [disabled]="isPlaceOrderDisabled()"
            class="bg-zestBlack block text-white rounded-lg py-4 px-8 mt-3 w-[90%] mx-auto text-sm lg:text-base disabled:bg-zestNeutral disabled:text-zestNeutral-300"
          >
            <mat-spinner
              [diameter]="18"
              class="justify-center items-center flex mx-auto text-zestWhite py-2 px-6"
              *ngIf="createPickupOrder; else addProduct"
            ></mat-spinner>
            <ng-template #addProduct><p>Place Order</p></ng-template>
          </button>

          <!-- Tab 3 payment options (SHIP) -->
          <div
            class="px-[17px]"
            *ngIf="openTab === 3 && receivedValue !== 'PICKUP_IN_STORE'"
          >
            <div class="w-full h-[52px] bg-ZTN-200 flex items-center mb-6">
              <h3 class="lg:text-xl text-lg font-bold text-zestBlack pl-8">Payment Options</h3>
            </div>
            <div class="">
              <div
                *ngFor="let option of options"
                class="mb-2 cursor-pointer transition-all duration-200"
                (click)="selectOption(option.value)"
              >
                <label class="grid grid-cols-12 cursor-pointer">
                  <div
                    class="w-6 h-6 col-span-1 rounded-full border-2 flex items-center justify-center transition-colors duration-200"
                    [ngClass]="{
                      'border-gray-400': selectedOption !== option.value,
                      'border-green-500': selectedOption === option.value
                    }"
                  >
                    <div
                      class="w-3 h-3 rounded-full transition-colors duration-200"
                      [ngClass]="{
                        'bg-transparent': selectedOption !== option.value,
                        'bg-green-500': selectedOption === option.value
                      }"
                    ></div>
                  </div>
                  <div class="col-span-11 text-[#101828]">
                    <h4 class="text-base font-bold text-[#101828]">{{ option.title }}</h4>
                    <p class="text-sm text-[#667085] font-medium">{{ option.description }}</p>
                  </div>
                </label>
              </div>
            </div>
          </div>

          <!-- Tab 3: Proceed to Payment -->
          <button
            *ngIf="openTab === 3 && receivedValue !== 'PICKUP_IN_STORE'"
            (click)="placeOrderAndPay()"
            class="bg-zestBlack block text-white rounded-lg py-4 px-8 mt-3 w-[90%] mx-auto text-sm lg:text-base"
          >
            <ng-container *ngIf="isProcessing; else addProduct">
              <mat-spinner
                [diameter]="18"
                class="justify-center items-center flex mx-auto text-zestWhite py-2 px-6"
              ></mat-spinner>
            </ng-container>
            <ng-template #addProduct><p>Proceed to Payment</p></ng-template>
          </button>

          <!-- Continue Shopping -->
          <button
            [routerLink]="['/stores', storeName | lowercase]"
            class="bg-zestBg text-zestBlack border-[#80909D] border text-sm lg:text-base rounded-lg py-4 px-8 mt-3 w-[90%] mx-auto"
          >
            Continue Shopping
          </button>

          <button [ngClass]="{ invisible: klumpHide }">
            <klump-checkout (btnClick)="pay()"></klump-checkout>
          </button>
        </div>
      </div>
    </section>

    <section class="my-8 px-5 lg:px-[154px] bg-[#F4F6F9]">
      <app-footer [storeName]="stores"></app-footer>
    </section>
  </main>
</ng-template>
